import React, { useEffect, useState } from 'react';
import AccessPermissionpage from './AccessPermissionpage';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getAllAssignedEmployeeByCompanyId, getAllAssignEmployeesByCampaignId, resendAssessmentLink } from '../../../services/api-services';
import { toastEmitter } from '../../../utills/utilities';
import { API_RESPONSE } from '../../../utills/app-constant';
import moment from 'moment';
import TableHeading from '../../components/common/TableHeading';
import SearchAndAddItem from '../../components/common/TableData';
import AdminDataTable from '../../components/common/AdminDataTable';
import { RIGHTARROW_ICON } from '../../../utills/image-constant';
import { ROUTES } from '../../routes/url-constant';

const AssignEmployeeByCompanyId = () => {
  const [pending, setPending] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [sortColumn, setSortColumn] = useState("id");
  const [sortDirection, setSortDirection] = useState("desc");
  const [permissionAccess, setPermissionAccess] = useState();
  const [totalElement, settotalElement] = useState();
  const { value } = useSelector((state) => state?.adminRole);

  const navigate = useNavigate();
  const location = useLocation();
  let assesmentData = location?.state?.Data;


  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const [empPayload, setEmpPayload] = useState({
    pageIndex: page,
    pageSize: pageSize,
    searchText: searchText,
    direction: sortDirection,
    filterByFieldName: sortColumn,
    status: 1,
    campaignId: "",
  });

  const [resendLinkpayload, setResendLinkpayload] = useState({
    campaignId: assesmentData?.id,
    employeeIdList: [],
    type: "online",
  });

  useEffect(() => {
    const RoleAccessFilterData =
      value && value?.filter((v) => v?.moduleName === "Campaign Management");
    setPermissionAccess(RoleAccessFilterData?.[0]);
  }, [value]);


   useEffect(() => {
    setEmpPayload((prevPayload) => ({
      ...prevPayload,
      campaignId: assesmentData?.id, // Update campaignId with assesmentData.id
    }));
  }, [assesmentData]);

  const getallAssignEmployee = async () => {
        if (!assesmentData?.id) {
      return; // Do not run if assesmentData?.id is not available
    }
    const data = {
      ...empPayload,
      campaignId: assesmentData?.id,
      pageIndex: page,
      pageSize: pageSize,
      searchText: searchText.trim(),
      filterByFieldName: sortColumn, // Pass the sort column here
    direction: sortDirection, // Pass the sort direction here
    };
  

    try {
      const response = await getAllAssignEmployeesByCampaignId(data);
      if (response?.data?.responseCode === 404) {
        setRowData([]);
      } else if (response?.data?.responseCode === 200) {
        const res = response?.data?.responseBody?.assignEmployeeList;
        console.log('res', res);
        setRowData(res);
        settotalElement(response?.data?.responseBody?.totalElement);
        setSelectedEmployees([]);
        setSelectAll(false);
      } else {
        toastEmitter("error", response?.data?.message);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    }
  };

useEffect(() => {
    if (assesmentData?.id) {
      getallAssignEmployee();
    }
  }, [assesmentData?.id, page, pageSize, searchText, sortColumn, sortDirection]);

  const handleModelSearchChange = (e) => {


    setSearchText(e.target.value);
  };

  const tableCustomStyles = {
    headRow: {
      style: {
        color: "#1B2128",
        fontSize: "14px",
      },
    },
    rows: {
      style: {
        color: "#1B2128",
        fontSize: "14px",
      },
    },
  };


  // const handleSelectAll = () => {
  //   if (!selectAll) {
  //     const allIds = rowData.map((emp) => emp.employeeResponse?.id);
  //     setSelectedEmployees(allIds);
  //     setResendLinkpayload((prevPayload) => ({
  //       ...prevPayload,
  //       employeeIdList: allIds,
  //     }));
  //   } else {
  //     setSelectedEmployees([]);
  //     setResendLinkpayload((prevPayload) => ({
  //       ...prevPayload,
  //       employeeIdList: [],
  //     }));
  //   }
  //   setSelectAll(!selectAll);
  // };


  // const handleCheckboxChange = (id) => {
  //   setSelectedEmployees((prevSelected) => {
  //     let updatedSelected;
  //     if (prevSelected.includes(id)) {
  //       updatedSelected = prevSelected.filter((eid) => eid !== id);
  //     } else {
  //       updatedSelected = [...prevSelected, id];
  //     }

  //     // Update resendLinkpayload at the same time
  //     setResendLinkpayload((prevPayload) => ({
  //       ...prevPayload,
  //       employeeIdList: updatedSelected,
  //     }));

  //     return updatedSelected;
  //   });
  // };

  // Update handleCheckboxChange to reflect the "Select All" checkbox behavior
  const handleCheckboxChange = (id) => {
    setSelectedEmployees((prevSelected) => {
      let updatedSelected;
      if (prevSelected.includes(id)) {
        updatedSelected = prevSelected.filter((eid) => eid !== id); // Unselect the item
      } else {
        updatedSelected = [...prevSelected, id]; // Select the item
      }

      // If no employees are selected, uncheck the "Select All" checkbox
      if (updatedSelected.length === 0) {
        setSelectAll(false); // Uncheck "Select All" when no checkboxes are selected
      }

      // If all employees are selected, check the "Select All" checkbox
      else if (updatedSelected.length === rowData.length) {
        setSelectAll(true); // Check "Select All" if all are selected
      }

      // Otherwise, uncheck the "Select All" checkbox if not all are selected
      else {
        setSelectAll(false); // Some are selected, but not all
      }

      // Update resendLinkpayload with the new list of selected employees
      setResendLinkpayload((prevPayload) => ({
        ...prevPayload,
        employeeIdList: updatedSelected,
      }));

      return updatedSelected;
    });
  };

  // Update handleSelectAll to uncheck all or check all employees
  const handleSelectAll = () => {
    if (!selectAll) {
      // If "Select All" is unchecked, select all employees
      const allIds = rowData
        .filter((emp) => emp.employeeResponse?.type !== "assessor") // exclude assessors
        .map((emp) => emp.employeeResponse?.id);
      setSelectedEmployees(allIds);
      setResendLinkpayload((prevPayload) => ({
        ...prevPayload,
        employeeIdList: allIds,
      }));
    } else {
      // If "Select All" is checked, unselect all employees
      setSelectedEmployees([]);
      setResendLinkpayload((prevPayload) => ({
        ...prevPayload,
        employeeIdList: [],
      }));
    }
    setSelectAll(!selectAll); // Toggle the "Select All" checkbox state
  };




  const handleResendLink = async () => {
    if (selectedEmployees.length === 0) {
      toastEmitter("warning", "Please select at least one employee!");
      return;
    }
    setPending(true);
    try {
      const response = await resendAssessmentLink(resendLinkpayload);
      if (response?.data?.responseCode === 404) {
        toastEmitter("error", response?.data?.message);
        setPending(false);
      } else if (response?.data?.responseCode === 200) {
        setPending(false);
        setSelectedEmployees([]);
        setSelectAll(false);
        setResendLinkpayload((prevPayload) => ({
          ...prevPayload,
          employeeIdList: [],
        }));
        toastEmitter("success", response?.data?.message);
      } else {
        setPending(false);
        toastEmitter("error", response?.data?.message);
      }
    } catch (err) {
      setPending(false);
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    }




  };

  console.log('rowData', rowData);

  const tblColumns = [
    {
      code: "select",
      name: (
        <input
          type="checkbox"
          checked={selectAll}
          onChange={handleSelectAll}
        />
      ),
      sortable: false,
      selector: (row) => {
        if (row?.employeeResponse?.type === "assessor") {
          // Render a fake checkbox for UI only
          return (
            <span className="fake-checkbox" />
          );
        } else {
          // Render a real checkbox for selectable employees
          return (
            <input
              type="checkbox"
              checked={selectedEmployees.includes(row?.employeeResponse?.id)}
              onChange={() => handleCheckboxChange(row?.employeeResponse?.id)}
            />
          );
        }
      },
      width: "60px",
    },
    {
      code: "employeeName",
      width: "180px",
      name: "Employee Name",
      sortable: true,
      selector: (row) => `${row?.employeeName}`,
    },
    {
      code: "employeeType",
      width: "180px",
      name: "Employee Type",
      sortable: false,
      selector: (row) => {
        const type = row?.employeeResponse?.type || "";
        return type.charAt(0).toUpperCase() + type.slice(1); // Capitalize first letter
      },
    },
    {
      code: "campaignName",
      name: "Name of Campaign",
      width: "180px",
      sortable: true,
      selector: (row) => `${row?.campaignName}`,
    },
    {
      code: "modelName",
      name: "Model Name",
      sortable: true,
      selector: (row) => `${row?.modelName}`,
    },
    {
      code: "email",
      name: "Email",
      sortable: false,
      selector: (row) => `${row?.email}`,
    },
    {
      code: "departmentName",
      name: "Deparmaent",
      sortable: true,
      selector: (row) => `${row?.employeeResponse?.department}`,
    },
    {
      code: "hierarchyName",
      name: "Hierarchy",
      sortable: true,
      selector: (row) => `${row?.employeeResponse?.hierarchy}`,
    },

    {
      code: "durationFromDate",
      name: "From Date",
      sortable: true,
      selector: (row) => moment(row?.durationFromDate).format("MM/DD/YYYY"),
    },
    {
      code: "durationToDate",
      name: "To Date",
      sortable: false,
      selector: (row) => moment(row?.durationToDate).format("MM/DD/YYYY"),
    },
    {
      code: "status",
      name: "Status",
      sortable: false,
      selector: (row) => {
        let badgeClass = "";
        let label = "";

        switch (row.isAssessment) {
          case 0:
            badgeClass = "badge bg-warning text-dark";
            label = "Not Started";
            break;
          case 1:
            badgeClass = "badge bg-danger";
            label = "Pending";
            break;
          case 2:
            badgeClass = "badge bg-success";
            label = "Completed";
            break;
          default:
            badgeClass = "badge bg-secondary";
            label = "Unknown";
        }

        return <span className={badgeClass}>{label}</span>;
      },
    }


  ];

  const handleNavigateBack = () => {
    navigate(ROUTES.VIEWASSIGNEDASSESSMENTS);
  };
  console.log('rowData', rowData);

  return (
    <>
      {permissionAccess?.addAction === 0 &&
        permissionAccess?.updateAction === 0 &&
        permissionAccess?.viewAction === 0 ? (
        <AccessPermissionpage />
      ) : (
        <>

          <div className="modal_datatable">
            <TableHeading
              className="cursor-pointer"
              firstData="Campaign Management"
              icon={RIGHTARROW_ICON}
              secondData="Employee"
              onFirstDataClick={handleNavigateBack}
            />
            <div className="container-fluid">
              <div className="caspera_admin_datatable mb-3">
                <SearchAndAddItem
                  searchValue={searchText}
                  onSearchChange={handleModelSearchChange}
                  data="Employee"
                  permissionAccessbtn={false}
                  showResendButton={true} // 🔹 show resend button
                  onResendClick={handleResendLink} // 🔹 resend handler
                  resendButtonDisabled={selectedEmployees.length === 0} // 🔹 disable if none selected
                />

                <AdminDataTable
                  _tblColumns={tblColumns}
                  _rowData={rowData}
                  tableCustomStyles={tableCustomStyles}
                  _totalRows={totalElement}
                  pending={pending}
                  setPending={setPending}
                  pageSize={pageSize}
                  page={page}
                  setPageSize={setPageSize}
                  setPage={setPage}
                  setSortColumn={setSortColumn}
                  setSortDirection={setSortDirection}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default AssignEmployeeByCompanyId;

